// extracted by mini-css-extract-plugin
export default {"App":"_Gallery_App__oUAWZ","gallery_page":"_Gallery_gallery_page__QWyZf","grid":"_Gallery_grid__Lmh13","image":"_Gallery_image__N1Gag"};